export default "__VITE_ASSET__DYGxviMq__"